import React, { useState } from "react";
import "./letConnect.scss";
import { PopupModal } from "../PopupModal";
import { Col, Row, Input, Form } from "antd";
import connect from "../../assets/images/connect_component/connect_right_img.png";
import { BookNowBtn } from "../BookNowBtn";

interface Props {
  padding: boolean;
}

const LetConnect = ({ padding }: Props) => {
  const [modalVisible, setModalVisible] = useState(false);

  const [formValues, setFormValues] = useState({
    Name: "",
    "Phone Number": "",
    "Email Address": "",
    Subject: "",
    Message: "",
  });

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleButtonClick = () => {
    if (Object.values(formValues).some((value) => value === "")) {
      return;
    }
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };
  return (
    <>
      <div
        className="connectMainDiv"
        style={{
          padding: padding ? "7.5rem 0" : "8vh 0",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Row className="mainRow">
          <Col
            xs={24}
            sm={16}
            md={16}
            lg={16}
            xl={16}
            xxl={16}
            className="leftDiv"
          >
            <h1 className="leftTitleHead">Let's Connect</h1>

            {/* <Col
              xs={21}
              sm={0}
              md={0}
              lg={0}
              xl={0}
              xxl={0}
              className="rightImageDiv mobileImage"
            >
              <img src={connect} className="rightImage" alt="NucleusTeq" />
            </Col> */}

            <Form
              name="basic"
              initialValues={{ remember: true }}
              className="leftFormInput"
              autoComplete="off"
            >
              <Row>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={11}
                  xl={11}
                  xxl={11}
                  className="leftFormName"
                >
                  <Form.Item
                    name="Name"
                    className="leftFormInput"
                    rules={[
                      { required: true, message: "Please input your Name!" },
                    ]}
                  >
                    <Input
                      className="formInput"
                      placeholder="Full Name"
                      bordered={false}
                      name="Name"
                      value={formValues.Name}
                      onChange={handleInputChange}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={24} lg={11} xl={11} xxl={11}>
                  <Form.Item
                    name="Email Address"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Email Address!",
                      },
                    ]}
                  >
                    <Input
                      className="formInput"
                      placeholder="Work Email"
                      bordered={false}
                      name="Work Email"
                      value={formValues["Email Address"]}
                      onChange={handleInputChange}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={11}
                  xl={11}
                  xxl={11}
                  className="leftFormName"
                >
                  <Form.Item
                    name="Subject"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Subject!",
                      },
                    ]}
                  >
                    <Input
                      className="formInput"
                      placeholder="Subject"
                      bordered={false}
                      name="Subject"
                      value={formValues["Subject"]}
                      onChange={handleInputChange}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={11} xl={11} xxl={11}>
                  <Form.Item
                    name="Phone Number"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Phone Number!",
                      },
                    ]}
                  >
                    <Input
                      className="formInput"
                      placeholder="Phone Number"
                      bordered={false}
                      name="Phone Number"
                      value={formValues["Phone Number"]}
                      onChange={handleInputChange}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Col span={24}>
                <Form.Item
                  name="Message"
                  rules={[
                    { required: true, message: "Please input your Message!" },
                  ]}
                >
                  <Input
                    className="formInput"
                    placeholder="Message"
                    bordered={false}
                    name="Message"
                    value={formValues.Message}
                    onChange={handleInputChange}
                  />
                </Form.Item>
              </Col>

              <Form.Item className="btnSubmitItem">
                <BookNowBtn
                  buttonText="Book a Consultation"
                  onClick={handleButtonClick}
                  modalShow={false}
                />
              </Form.Item>
            </Form>
          </Col>
          {/* <Col xs={0} sm={14} md={14} lg={14} xl={14} xxl={14}>
            <img src={connect} className="rightImage" alt="NucleusTeq" />
          </Col> */}
        </Row>
      </div>
      <PopupModal
        modalVisible={modalVisible}
        closeModal={handleModalClose}
        heading="Submitted!"
        text="We Will Get Back To You Soon."
      />
    </>
  );
};
export default LetConnect;
